import React from 'react';
import { COMPANY, WHY_US } from '../../data/siteData';
import SectionHeader from '../common/SectionHeader';
import Button from '../common/Button';

export default function AboutSection() {
  return (
    <section id="about" className="section" style={{ background: 'var(--ink-soft)', width: '100%', overflow: 'hidden' }}>
      <div className="container">

        {/* Two-column on desktop, single on mobile */}
        <div className="about-grid">

          {/* Visual — hidden on mobile to save space */}
          <div style={{
            aspectRatio: '4/5',
            background: 'rgba(201,168,76,0.04)',
            border: '1px solid var(--gold-border)',
            borderRadius: 'var(--radius-md)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            position: 'relative', overflow: 'hidden',
          }}>
            <div style={{
              position: 'absolute', inset: 0,
              backgroundImage: 'linear-gradient(rgba(201,168,76,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(201,168,76,0.06) 1px, transparent 1px)',
              backgroundSize: '40px 40px',
            }} />
            <div style={{
              width: '140px', height: '140px',
              background: 'var(--gold)', borderRadius: '50%',
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center',
              fontFamily: 'var(--font-serif)', fontWeight: 700,
              color: 'var(--ink)', position: 'relative', zIndex: 1,
            }}>
              <div style={{ fontSize: '36px', lineHeight: 1 }}>5+</div>
              <div style={{ fontSize: '11px', letterSpacing: '0.06em', textAlign: 'center', marginTop: '4px' }}>
                YEARS<br />COMBINED<br />EXPERIENCE
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <SectionHeader tag="About Us" title='Built on <em style="color:var(--gold);font-style:normal">Integrity,</em> Driven by Results' />
            <p style={{ fontSize: '15px', color: 'var(--text-secondary)', lineHeight: 1.85, fontWeight: 300, marginBottom: '16px' }}>
              {COMPANY.name} was founded with a singular belief: that every client — from first-time investors to seasoned traders — deserves access to professional-grade financial intelligence and infrastructure.
            </p>
            <p style={{ fontSize: '15px', color: 'var(--text-secondary)', lineHeight: 1.85, fontWeight: 300, marginBottom: '28px' }}>
              We are fully registered, transparent, and deeply committed to ethical financial practice that puts your growth first.
            </p>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '32px' }}>
              {[
                'Fully compliant with applicable financial regulations',
                'Non-custodial and client-first approach',
                'Dedicated account managers for every client',
                'Transparent fee structures — no hidden costs',
              ].map((item, i) => (
                <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', fontSize: '14px', color: 'var(--cream)' }}>
                  <span style={{ width: '20px', height: '1px', background: 'var(--gold)', flexShrink: 0, marginTop: '10px' }} />
                  {item}
                </li>
              ))}
            </ul>
            <Button variant="primary" href="#contact">Work With Us</Button>
          </div>
        </div>

        {/* Why Us */}
        <SectionHeader tag="Why Choose Us" title={`The <em style="color:var(--gold);font-style:normal">${COMPANY.shortName}</em> Advantage`} center />
        <div className="why-grid">
          {WHY_US.map((item, i) => (
            <div key={i} style={{
              padding: '28px',
              background: 'rgba(201,168,76,0.04)',
              border: '1px solid var(--gold-border)',
              borderRadius: 'var(--radius-md)',
            }}>
              <h4 style={{ fontFamily: 'var(--font-serif)', fontSize: '17px', marginBottom: '10px', color: 'var(--text-primary)' }}>
                {item.title}
              </h4>
              <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 1.75, fontWeight: 300 }}>
                {item.body}
              </p>
            </div>
          ))}
        </div>

      </div>

      <style>{`
        @media (max-width: 768px) {
          .about-grid > div:first-child { display: none; }
          .why-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
